import React from "react";
import { createSvgIcon } from "@mui/material/utils";
export const MOON_PATH = "M21.9,13.4c-0.2-0.5-0.8-0.7-1.3-0.5c-1.1,0.5-2.2,0.7-3.4,0.7c-0.7,0-1.4-0.1-2-0.3c-4.3-1.1-7-5.5-5.9-9.9c0.1-0.2,0-0.5-0.1-0.7C9,2.4,8.5,2.1,7.9,2.4C4.3,4,2,7.6,2,11.6c0,5.6,4.5,10.1,10.1,10.1c4.6,0,8.7-3.2,9.8-7.7C22,13.8,22,13.6,21.9,13.4z";
const Moon = createSvgIcon(/*#__PURE__*/React.createElement("path", {
  d: MOON_PATH
}), "Moon");
export default Moon;